// extracted by mini-css-extract-plugin
export default {"container":"UserDetail_container__12T1-","header":"UserDetail_header__3JAcX"};